import React from "react";
import styles from "./FeatureTag.module.scss";

export default function FeatureTag({ feature }: { feature: string }) {
  return (
    <div className={styles.featureItem}>
      <span className={styles.featureText}>{feature}</span>
    </div>
  );
}
